import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { DashboardLayout } from './layouts/DashboardLayout';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { DashboardPage } from './pages/DashboardPage';
import { AgentsPage } from './pages/AgentsPage';
import { LeadsPage } from './pages/LeadsPage';
import { PricingPage } from './pages/PricingPage';
import { SettingsPage } from './pages/SettingsPage';
import { CalendarPage } from './pages/CalendarPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { CallsPage } from './pages/CallsPage';
import { WebBuilderPage } from './pages/WebBuilderPage';
import { GeoPage } from './pages/GeoPage';
import { CampaignSimulatorPage } from './pages/CampaignSimulatorPage';
import { WhatsAppCommercePage } from './pages/WhatsAppCommercePage';
import { FestivePage } from './pages/FestivePage';
import { BharatVoicePage } from './pages/BharatVoicePage';
import { BrandMonitorPage } from './pages/BrandMonitorPage';
import { NriMarketingPage } from './pages/NriMarketingPage';
import { AgenticAdsPage } from './pages/AgenticAdsPage';
import { AppBuilderPage } from './pages/AppBuilderPage';
import { MarketplacePage } from './pages/MarketplacePage';
import { BlockchainTrustPage } from './pages/BlockchainTrustPage';
import { FaqPage } from './pages/FaqPage';
import { SupportPage } from './pages/SupportPage';
import { OnboardingReportPage } from './pages/OnboardingReportPage';
import { ContentGeneratorPage } from './pages/ContentGeneratorPage';
import { AgentOpsPage } from './pages/AgentOpsPage';
import { CopyProvider } from './context/CopyContext';
import { ToastProvider } from './context/ToastContext';
import PWAInstallPrompt from './components/PWAInstallPrompt';

function App() {
  return (
    <CopyProvider>
      <ToastProvider>
      <Router>
        <div className="min-h-screen" style={{ background: 'var(--bg)', color: 'var(--text)' }}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <OnboardingPage />
                </ProtectedRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/onboarding-report" element={<OnboardingReportPage />} />
              <Route path="/agents" element={<AgentsPage />} />
              <Route path="/leads" element={<LeadsPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/calls" element={<CallsPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/webbuilder" element={<WebBuilderPage />} />
              <Route path="/geo" element={<GeoPage />} />
              <Route path="/simulator" element={<CampaignSimulatorPage />} />
              <Route path="/whatsapp-commerce" element={React.createElement(WhatsAppCommercePage)} />
              <Route path="/festive" element={React.createElement(FestivePage)} />
              <Route path="/bharat-voice" element={React.createElement(BharatVoicePage)} />
              <Route path="/brand-monitor" element={React.createElement(BrandMonitorPage)} />
              <Route path="/nri-marketing" element={React.createElement(NriMarketingPage)} />
              <Route path="/agentic-ads" element={React.createElement(AgenticAdsPage)} />
              <Route path="/app-builder" element={React.createElement(AppBuilderPage)} />
              <Route path="/marketplace" element={React.createElement(MarketplacePage)} />
              <Route path="/blockchain-trust" element={React.createElement(BlockchainTrustPage)} />
              <Route path="/support" element={React.createElement(SupportPage)} />
              <Route path="/content-generator" element={<ContentGeneratorPage />} />
              <Route path="/agent-ops" element={<AgentOpsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
      <PWAInstallPrompt />
      </ToastProvider>
    </CopyProvider>
  );
}

export default App;
